module.exports = __webpack_public_path__ + "static/values_2-91a16a10147c751e6e8344e373159c70.svg";